export default __webpack_public_path__ + "ab_aggregation_formula.png";